import {useMutation} from "react-query";
import axios from "services/axios";

export function useSuspendArticle(options = {}) {
	return useMutation(values => axios.post("/article/change-suspend", values).then(res => res.data), options);
}
